"use client";

import { useEffect, useState } from "react";

declare const window: any;

const useShowFooter = () => 
{
    const [ show, setShow ] = useState(true);
    const [ lastScrollY, setLastScrollY ] = useState(0);

    const controlNavbar = () => 
    {
        if (typeof window !== "undefined") 
        {
            if (window.scrollY > lastScrollY) 
            {
                if (window.scrollY - lastScrollY > 0)
                {
                    setShow(false);
                }        
            }
            else 
            {
                setShow(true);
            }

            setLastScrollY(window.scrollY);
        }
    };

    useEffect(() => 
    {
        if (typeof window !== "undefined") 
        {
            window.addEventListener("scroll", controlNavbar);

            return () => 
            {
                window.removeEventListener("scroll", controlNavbar);
            };
        }
    }, [ lastScrollY ]);

    return show;
};

export default useShowFooter;
